import { render } from "./PlatformGuide.vue?vue&type=template&id=c852196c&scoped=true"
import script from "./PlatformGuide.vue?vue&type=script&lang=js"
export * from "./PlatformGuide.vue?vue&type=script&lang=js"

import "./PlatformGuide.vue?vue&type=style&index=0&id=c852196c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c852196c"]])

export default __exports__